const getImageProps = (encodedImage) => {
    const mimeMatch = encodedImage.match(/^data:(image\/\w+);base64,/);
    const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';

    const base64 = encodedImage.replace(/^data:image\/\w+;base64,/, '');
    const byteSize = Math.ceil((base64.length * 3) / 4);

    return new Promise((resolve) => {
        const img = new window.Image();
        img.onload = function () {
            resolve({
                mime,
                byteSize,
                width: img.width,
                height: img.height,
            });
        };
        img.src = `data:${mime};base64,${base64}`;
    });
};

const base64ToBlob = (base64, mimeType = 'image/jpeg') => {
    const byteString = atob(base64);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
};

export { getImageProps, base64ToBlob };
